import { render, staticRenderFns } from "./rukujianying.vue?vue&type=template&id=370dffd4&scoped=true"
import script from "./rukujianying.vue?vue&type=script&lang=js"
export * from "./rukujianying.vue?vue&type=script&lang=js"
import style0 from "./rukujianying.vue?vue&type=style&index=0&id=370dffd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370dffd4",
  null
  
)

export default component.exports